import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_EMPLOYEE_DROPDOWN,
    getEmployeeDropdownFail,
    getEmployeeDropdownSuccess
} from '../action/getEmployeeDropdownAction'

// api 
import getEmployeeDropdownApi from '../api/getEmployeeDropdownApi'

export function* getEmployeeDropdownSaga(action) {
    try {
        const response = yield call(() => getEmployeeDropdownApi(action.params))
        if (response.data.status === 1) {
            yield put(getEmployeeDropdownSuccess(response, action))
        } else {
            yield put(getEmployeeDropdownFail(response, action))
        }
    } catch (e) {
        yield put(getEmployeeDropdownFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_EMPLOYEE_DROPDOWN, getEmployeeDropdownSaga)
}